import axios from '@/utils/request'

/* 账号登录 */
export function login(data) {
  return axios({
    url: '/user/login',
    method: 'post',
    data: data
  })
}

/* 手机登录 */
export function phoneLogin(data) {
  return axios({
    url: '/user/phone_login_get_list',
    method: 'post',
    data: data
  })
}
/* 手机号登录，选择账号 */
export function phoneCheckLogin(data) {
  return axios({
    url: '/user/phone_login_select_promote',
    method: 'post',
    data: data
  })
}
/* 获取验证码 */
export function code(data) {
  return axios({
    url: '/user/phone_login_send_sms',
    method: 'post',
    data: data
  })
}

/* 用户信息 */
export function getUser(data) {
  return axios({
    url: '/user/userinfo',
    method: 'post',
    data: data
  })
}

/* 内团登录 */
export function innerLogin(data) {
  return axios({
    url: '/admin_function/login',
    method: 'post',
    data: data
  })
}

/* 微信登录 */
export function wxLogin(data) {
  return axios({
    url: '/user/oauth_login2',
    method: 'post',
    data: data
  })
}


/* 注册 */
export function register(data) {
  return axios({
    url: '/user/register',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js